import { datagridProps } from "../common";
import ListDetail from "../../components/ListDetail";
import furnitureCategoryForm from "../../dtos/forms/furniture/Category";
import furnitureForm from "../../dtos/forms/furniture";
import { api } from "@cetma/skeleton-app/index";
import { ConfirmDialogLabel } from "@cetma/skeleton-app/components/ConfirmDialog";
import { translate } from "@cetma/skeleton-app/util";
import { FormLabel } from "@cetma/skeleton-app/components/Crud/Form";
import { TableLabel } from "@cetma/skeleton-app/components/Crud/Table";

export default function FurnitureCategory() {

    const confirmDialogLabel: ConfirmDialogLabel = {
        title: translate('confirmDialog.title'),
        text: translate('confirmDialog.text'),
        confirm: translate('confirmDialog.confirm'),
        cancel: translate('confirmDialog.cancel')
    };

    const formLabel: FormLabel = {
        edit: translate('form.edit'),
        entity: translate('furniture'),
        new: translate('form.new'),
        reset: translate('form.reset'),
        save: translate('form.save')
    };

    const tableLabel: Partial<TableLabel> = {
        delete: translate('table.delete'),
        deleteRows: translate('table.deleteRows'),
        add: translate('table.add'),
        edit: translate('table.edit'),
        close: translate('table.close'),
        refresh: translate('table.refresh'),
        noRowsLabel: translate('table.noRowsLabel')
    }

    return (
        <ListDetail 
            api={api}
            listEntity={{name: 'furnitureCategory', label: 'Furniture cateogry'}}
            listForm={furnitureCategoryForm}
            detailEntity={{name: 'furniture', label: 'Furniture', select: ['furnitureId', 'furnitureName', 'furnitureImg']}}
            detailForm={furnitureForm}
            datagridProps={datagridProps}
            formLabel={formLabel}
            tableLabel={tableLabel}
            confirmDialogLabel={confirmDialogLabel}
            joinField="furnitureCategoryId"
        />
    )
}